import { useEffect, useState } from 'react';
import { Option } from 'shared/types/general';
import { equipmentApi } from '../api/equipmentApi';
import { EquipmentLinkMode } from '../types';

export const useEquipmentCostLinkOptions = (mode: EquipmentLinkMode) => {
  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    equipmentApi.getLinkOptions(mode).then(setOptions);
  }, [mode]);

  return { options };
};
